<template>
  <div>
    <VotePc v-if="false"></VotePc>
    <VoteMobile v-if="false"></VoteMobile>
  </div>
</template>

<script>
import {IsPC} from "@/util/common";
import VotePc from "@/views/Vote/Pc";
import VoteMobile from "@/views/Vote/Mobile";

export default {
  components: {VoteMobile, VotePc},
  name: 'Vote',
  data() {
    return {
      isPc: IsPC()
    }
  },
  props: {},
  computed: {},
  methods: {},
  watch: {},
  created() {
  },
  mounted() {
    this.$alert('投票已结束，感谢关注', {
      showClose: false,
      showConfirmButton: false,
      showCancelButton: false
    }).then(() => {
      window.location.href = 'https://jj.brandzg.net'
    });
    window.setTimeout(() => {
      window.location.href = 'https://jj.brandzg.net'
    }, 4000);
  }
}
</script>

<style>
@media screen and (max-width: 420px) {
  .el-message-box {
    width: 100vw;
    box-sizing: border-box;
  }
}

.el-message-box__content {
  font-size: 20px !important;
}
</style>
